export default __webpack_public_path__ + "i18n/translations/translation-es.42e283a9.json";